class VwHbsOrderDTO {
    id: number = 0;
    kimlikId?: number = null;
    muracaatId?: number = null;
    hastaservisId?: number = null;
    organizasyonId?: number = null;
    tarih?: string = null;
    servisId?: number = null;
    doktorId?: number = null;
    aciklama?: string = "";
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    iptal?: string = "H";
    iptalKullanici?: number = null;
    iptalTarihi?: string = null;
    diskayit?: string = "H";
    gonderilecekOrganizasyonId?: number = null;
    servisAdi?: string = "";
    doktorAdi?: string = "";
};
export default VwHbsOrderDTO;